import i18n from '../../i18n';
var VoucherStrings = {
    title: function () { return 'Vouchers'; },
    description: function () {
        return 'Create a voucher to treat your team and guests for an one-time event.';
    },
    button: function () { return 'Create voucher'; },
    voucherStatus: {
        live: function () { return "Live"; },
        upcoming: function () { return "Upcoming"; },
        expired: function () { return "Expired"; },
    },
    editTag: function () { return 'Edit'; },
    deleteTag: function () { return 'Delete'; },
    shareButton: function () { return 'Share'; },
    created: function () { return 'Created'; },
    accepted: function () { return 'Accepted'; },
    vouchers: function () { return 'Vouchers'; },
    emptyVouchersPage: {
        title: function () { return 'How does it work?'; },
        step1: function () { return 'Create single or bulk vouchers.'; },
        step2: function () { return 'Send vouchers by email or link.'; },
        step3: function () { return 'Recipients can use voucher with any DoorDash account.'; },
    },
    detailPage: {
        backCtaText: function () { return 'Back to vouchers'; },
        shareCtaText: function () { return 'Share'; },
        editCtaAccessibilityLabel: function () { return 'Edit'; },
        deleteCtaAccessibilityLabel: function () { return 'Delete'; },
        createdColumnLabel: function () { return 'Created'; },
        sentColumnLabel: function () { return 'Sent'; },
        acceptedColumnLabel: function () { return 'Accepted'; },
        orderedColumnLabel: function () { return 'Ordered'; },
        sentStatusLabel: function () { return 'Sent'; },
        acceptedStatusLabel: function () { return 'Accepted'; },
        orderedStatusLabel: function () { return 'Ordered'; },
        totalSpentColumnLabel: function () { return 'Total spent'; },
        emailAddressTableColumnLabel: function () { return 'Email address'; },
        statusTableColumnLabel: function () { return 'Status'; },
        spendTableColumnLabel: function () { return 'Spend'; },
        noMembersView: {
            imageAltText: function () { return 'No members'; },
            title: function () { return 'No activity yet'; },
            body: function () {
                return "We'll provide more details once someone accepts your voucher.";
            },
            shareCtaText: function () { return 'Share voucher'; },
        },
    },
    shareFlow: {
        inviteSentSuccessToastMessage: function () { return "1 email invite sent"; },
        inviteSentSuccessToastMessagePlural: function (count) {
            return count + " email invites sent";
        },
        linkCopiedToastMessage: function () { return 'Link copied'; },
        addRecipientsModal: {
            title: function () { return 'Add more recipients'; },
            body: function () {
                return 'You reached the limit for this voucher. You can share it with more people by adding more recipients.';
            },
            editVoucherCtaText: function () { return 'Edit voucher'; },
            cancelCtaText: function () { return 'Cancel'; },
        },
        addCardModal: {
            title: function () { return 'A payment method is required'; },
            subtitle: function () {
                return 'Add a default payment method for all of your company benefits.';
            },
            saveAndCopyLinkCtaText: function () { return 'Save and copy link'; },
            saveAndCopyLinkCtaTextV2: function () { return 'Save and get link'; },
            saveAndAddEmailsCtaTextV2: function () { return 'Save and add email addresses'; },
            saveAndShareCtaText: function () { return 'Save and share'; },
            cancelSharingCtaText: function () { return 'Cancel sharing'; },
        },
    },
    shareVoucherModal: {
        title: function () { return 'Share voucher'; },
        shareOptionAccesibilityLabel: function () { return 'Share option'; },
        shareByLinkOptionLabel: function () { return 'Share by link'; },
        shareByEmailOptionLabel: function () { return 'Share by email'; },
        shareByLinkContent: {
            shareLinkFieldLabel: function () { return 'Copy link with message'; },
            shareLinkMessage: function (value, voucherName, url) {
                return "Here's a " + value + " DoorDash voucher for " + voucherName + ". Follow this link to accept the voucher: " + url;
            },
            needToAddPaymentShareLinkFieldValue: function () {
                return 'We will copy a shareable link after payment is added.';
            },
            description: function () {
                return 'Anyone with the link will be able to use the voucher.';
            },
            copyLinkCtaText: function () { return 'Copy link'; },
            linkCopiedCtaText: function () { return 'Link copied'; },
            shareLaterCtaText: function () { return "I'll share later"; },
            continueToPaymentCtaText: function () { return 'Continue to payment'; },
        },
        shareByEmailContent: {
            emailIsRequiredError: function () { return 'Email is required.'; },
            notValidEmailError: function (email) { return email + " is not a valid email."; },
            notValidEmailErrorPlural: function (emails) {
                return emails.join(', ') + " are not valid emails.";
            },
            emailTextAreaFieldLabel: function () { return 'Enter recipient email'; },
            description: function () { return 'Emails can be from your team or external recipients'; },
            shareVoucherCtaText: function () { return 'Share voucher'; },
            shareLaterCtaText: function () { return "I'll share later"; },
            continueToPaymentCtaText: function () { return 'Continue to payment'; },
        },
    },
    editVoucher: {
        editSuccessToast: function () { return 'Voucher updated.'; },
    },
    shareVoucherOptionModal: {
        title: function (name) { return "Share " + name; },
        subtitle: function () { return "Choose how you'd like to share this voucher."; },
        shareByEmailTitle: function () { return 'Email recipients a unique link'; },
        shareByEmailSubtitle: function () {
            return 'Send your voucher by email. Each recipient will get their own unique link.';
        },
        shareGenericLinkTitle: function () { return 'Create a general link'; },
        shareGenericLinkSubtitle: function () {
            return 'Get a link to distribute to your team. Anyone with the link can claim the voucher.';
        },
        shareLaterCtaText: function () { return "I'll share later"; },
        optionAccessibilityLabel: function () { return 'Select a share option'; },
        continueCtaText: function () { return 'Continue'; },
        continueToPaymentCtaText: function () { return 'Continue to payment'; },
        paymentMethodRequiredBannerText: function () {
            return 'A payment method is required to share the voucher.';
        },
    },
    shareByLinkModal: {
        title: function (name) { return "Share " + name + " by link"; },
        subtitle: function () { return "Anyone with the link can claim the voucher."; },
        shareLinkMessage: function (value, voucherName, url) {
            return "Here's a " + value + " DoorDash voucher for " + voucherName + ". Follow this link to accept the voucher: " + url;
        },
        copyLinkCtaText: function () { return 'Copy link'; },
        linkCopiedCtaText: function () { return 'Link copied'; },
        copyMessageWithLinkCtaText: function () { return 'Copy message with link'; },
        messageCopiedCtaText: function () { return 'Message copied'; },
    },
    shareByEmailModal: {
        title: function (name) { return "Share " + name + " by email"; },
        subtitle: function () { return "Each recipient will get their own unique link."; },
        addRecipientTextFieldLabel: function () { return 'Add the recipient emails'; },
        addReceipientTextFieldPlaceholder: function () {
            return 'email.1@company.com, email.2@company.com';
        },
        addRecipientTextFieldDescription: function () { return 'Required'; },
        addReceipientTextFieldHint: function () {
            return 'Email addresses can be separated by commas, new lines, or spaces';
        },
        emailIsRequiredError: function () { return 'Add recipients to share the voucher'; },
        notValidEmailError: function (email) { return email + " is not a valid email."; },
        notValidEmailErrorPlural: function (emails) {
            return emails.join(', ') + " are not valid emails.";
        },
        tooManyEmailsError: function (limit) {
            return "You can only send up to " + limit + " emails at a time.";
        },
        limitReachedBannerTitle: function () {
            return 'You reached the limit of recipients for this voucher';
        },
        limitReachedBannerSingularText: function (oldValue, newValue, increasedBy) {
            return "Remove " + increasedBy + " new recipient, or we'll automatically increase the voucher total from " + oldValue + " to " + newValue + ".";
        },
        limitReachedBannerPluralText: function (oldValue, newValue, increasedBy) {
            return "Remove " + increasedBy + " new recipients, or we'll automatically increase the voucher total from " + oldValue + " to " + newValue + ".";
        },
        cancelButtonCtaText: function () { return 'Cancel'; },
        confirmAndShareButtonCtaText: function () { return 'Confirm and share'; },
        shareButtonCtaText: function () { return 'Share voucher'; },
    },
    previewVoucherPage: {
        title: function (teamName) {
            return i18n.t('vouchers_previewVoucherPage_title', { teamName: teamName });
        },
        acceptButton: function () { return i18n.t('vouchers_previewVoucherPage_acceptButton'); },
        termsAndConditionsLink: function () {
            return i18n.t('vouchers_previewVoucherPage_termsAndConditionsLink');
        },
        privacyPolicyLink: function () {
            return i18n.t('vouchers_previewVoucherPage_privacyPolicyLink');
        },
        titleV2: function () { return i18n.t('vouchers_previewVoucherPage_titleV2'); },
        subTitleV2: function (teamName) {
            return i18n.t('vouchers_previewVoucherPage_subTitleV2', { teamName: teamName });
        },
        otherAccountButton: function () {
            return i18n.t('vouchers_previewVoucherPage_useAnotherAccountV2');
        },
        currentAccountButton: function (accountEmail) {
            return i18n.t('vouchers_previewVoucherPage_useCurrentAccountV2', {
                accountEmail: accountEmail,
            });
        },
        termsAndConditionsV2: function () {
            return i18n.t('vouchers_previewVoucherPage_termsAndConditionsV2');
        },
        agreementV2: function () { return i18n.t('vouchers_previewVoucherPage_agreementV2'); },
        acceptVoucherV2: function () {
            return i18n.t('vouchers_previewVoucherPage_acceptVoucherV2');
        },
    },
    acceptVoucherPage: {
        title: function () { return i18n.t('vouchers_acceptVoucherPage_title'); },
        voucherDetails: function () { return i18n.t('vouchers_acceptVoucherPage_voucherDetails'); },
        voucherName: function () { return i18n.t('vouchers_acceptVoucherPage_voucherName'); },
        voucherIssuer: function () { return i18n.t('vouchers_acceptVoucherPage_voucherIssuer'); },
        voucherValue: function () { return i18n.t('vouchers_acceptVoucherPage_voucherValue'); },
        voucherValidFor: function () { return i18n.t('vouchers_acceptVoucherPage_voucherValidFor'); },
        confirmationButton: function () {
            return i18n.t('vouchers_acceptVoucherPage_confirmationButton');
        },
        guideTitle1: function () { return i18n.t('vouchers_acceptVoucherPage_guideTitle1'); },
        guideStep1: function () { return i18n.t('vouchers_acceptVoucherPage_guideStep1'); },
        guideStep2: function () { return i18n.t('vouchers_acceptVoucherPage_guideStep2'); },
        guideStep3: function () { return i18n.t('vouchers_acceptVoucherPage_guideStep3'); },
        guideTitle2: function () { return i18n.t('vouchers_acceptVoucherPage_guideTitle2'); },
        supportNumber: function () { return i18n.t('vouchers_acceptVoucherPage_supportNumber'); },
        helpCenterLink: function () { return i18n.t('vouchers_acceptVoucherPage_helpCenterLink'); },
    },
    voucherErrorPage: {
        closeButton: function () { return i18n.t('vouchers_errorPage_closeButton'); },
        unspecifiedErrorMessage: function () {
            return i18n.t('vouchers_previewVoucherRedemptionErrorCode_unspecifiedMessage');
        },
    },
};
export default VoucherStrings;
